import { Injectable } from '@angular/core';
import { ExpenseCountItem, Expense } from './expense';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { GlobalService } from './../core/global.service';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  find(params): Observable<Expense[]> {
    const api = (<any>_GlobalNS).api.expense.search;
    return this._http.get<Expense[]>(`${api}`, { params });
  }

  findCounterByPropertyId(): Observable<ExpenseCountItem> {
    const api = (<any>_GlobalNS).api.expense.counter;
    const propertyId = this._global.find((<any>_GlobalNS).paths.PropertyId);
    const params = new HttpParams().set('PropertyId', propertyId);
    return this._http.get<ExpenseCountItem>(`${api}`, { params });
  }
}
